import { Injectable } from '@angular/core';
import moment from 'moment';
import { AuthService } from 'src/app/@auth/auth.service';
import { v4 as uuidv4 } from 'uuid';
import { RxCluZTickTraceDocumentType } from '../@schemas/clu_zticktrace.schema';
import { CashDeskCoreRxDbService } from './m-cashdesk-core-rxdb.service';
import { CluTickItem } from '../@models/clutick.model';
import { TauriService } from 'src/app/services/tauri/tauri.service';
import { RxPDeviceDocumentType } from '../@schemas/p_device.schema';

@Injectable()
export class CashDeskZCluZTickTraceService {

    constructor(
        private _authService : AuthService,
        private _cashDeskRxDbService : CashDeskCoreRxDbService,
        private _tauriService: TauriService
    ) {

    }

    private async doGetGenerateDefaultZTickTraceItem_ZTickTraceFn(DO_PIECE_INTERNAL : string, TRACE_EVT_DATA : string, TRACE_EVT_DATA_RXDB : string) : Promise<RxCluZTickTraceDocumentType | null> {
        const authSessionDto: any = this._authService.authenticatedSession$.value!;
        if(!authSessionDto || !authSessionDto.SITE_ITEM || !authSessionDto.FO_PARAMS || !authSessionDto.FO_PARAMS.M_CAISSE_PERM || !authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM) return null;

        let DEVICE : RxPDeviceDocumentType | null = null;
        if (this._tauriService.isTauri) {
          try { DEVICE = await this._tauriService.doGetPDeviceItemByCaissegidAction(localStorage.getItem('LS_FE_AUTH_CASHDESK_GID')!); } catch {}
        } else {
          const query_DEVICE = this._cashDeskRxDbService.db.pdevice.findOne({ selector: { "CAISSEGID": { "$eq": localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') } }});
          DEVICE = await query_DEVICE.exec();
        }
        if(!DEVICE) return null;

        let _ztickTraceItem = {
            TRACE_GID : uuidv4(),
            TRACE_DATEEVENT : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
            DO_PIECE_INTERNAL : DO_PIECE_INTERNAL,
            TRACE_EVT_DATA : TRACE_EVT_DATA ?? '',
            TRACE_EVT_DATA_RXDB : TRACE_EVT_DATA_RXDB ?? '',
            USER_GID : authSessionDto.ID,
            MD_SITEGID : authSessionDto.SITE_ITEM.SITEGID,
            MD_SITE_LIB : authSessionDto.SITE_ITEM.S_DENOMINATION,
            MD_CAISSE : localStorage.getItem('LS_FE_AUTH_CASHDESK_GID') || '',
            MD_CAISSE_LIB : DEVICE!.C_NO + ' ' + DEVICE!.C_DENOMINATION,
            MD_CAISSIERGID : authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.CAISSIERGID,
            MD_CAISSIER_LIB : authSessionDto.FO_PARAMS.M_CAISSE_PERM.CASHIER_ITEM.CLU_USERLIB,
            MD_CAISSE_SESSION : DEVICE!.CAISSE_SESSION || '',
            MD_SITE_SESSION : DEVICE!.SITE_SESSION || '',
            MD_LOCALGID : DEVICE!.CAISSE_SESSION_OUVERTURE_PAR_LOCALGID ?? '',
            ZSYNCUP_FLAG : 0,
            ZSYNCUP_STATUS : 'pending',
            ZSYNCUP_ERROR_MESSAGE : '',
            ZSYNCUP_DATETIME : '',
            ZSYNCUP_FEEDID : ''
        };
        return _ztickTraceItem;
    }

    private async runQuery_doGetCluTickItem(DO_PIECE_INTERNAL : string) : Promise<CluTickItem> {
        if (this._tauriService.isTauri) {
            const cluTickItemRaw = await this._tauriService.doGetCluTickEnteteByDoPieceInternalAction(DO_PIECE_INTERNAL);
            const cluTickItem = Object.assign(new CluTickItem(), cluTickItemRaw);
            return cluTickItem;
        } else {
            const query_ENTETE = this._cashDeskRxDbService.db.clutickentete.findOne({
                selector: {
                    "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL }
                },
                sort: []
            });
            const query_LIGNES = this._cashDeskRxDbService.db.clutickligne.find({
                selector: {
                    "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL }
                },
                sort: [{ DL_LIGNE: 'asc' }]
            });
            const query_REGLEMENTS = this._cashDeskRxDbService.db.clutickreglement.find({
                selector: {
                    "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL }
                },
                sort: []
            });
            let ENTETE = await query_ENTETE.exec();
            let LIGNES = await query_LIGNES.exec();
            let REGLEMENTS = await query_REGLEMENTS.exec();
            let cluTickItem = new CluTickItem();
            cluTickItem.ENTETE = JSON.parse(JSON.stringify(ENTETE));
            cluTickItem.LIGNES = JSON.parse(JSON.stringify(LIGNES));
            cluTickItem.REGLEMENTS = JSON.parse(JSON.stringify(REGLEMENTS));
            return cluTickItem;
        }
    }

    async doLogCashDeskTickTraceEvent_ZTickTraceFn(_cluTickItem : CluTickItem) {
        try
        {
            if(!_cluTickItem || !_cluTickItem.ENTETE || !_cluTickItem.ENTETE.DO_PIECE_INTERNAL) return;
            let TRACE_EVT_DATA = JSON.stringify(_cluTickItem);
            let TRACE_EVT_DATA_RXDB = '';
            try {
                let _cluTickItem_RXDB = await this.runQuery_doGetCluTickItem(_cluTickItem.ENTETE.DO_PIECE_INTERNAL);
                TRACE_EVT_DATA_RXDB = JSON.stringify(_cluTickItem_RXDB);
            } catch { }
            let _ztickTraceItem = await this.doGetGenerateDefaultZTickTraceItem_ZTickTraceFn(_cluTickItem.ENTETE.DO_PIECE_INTERNAL, TRACE_EVT_DATA, TRACE_EVT_DATA_RXDB);
            if(!_ztickTraceItem || !_ztickTraceItem.MD_CAISSE_SESSION) return;
            await this._cashDeskRxDbService.db.cluzticktrace.insert(_ztickTraceItem);
        }
        catch { }
    }

}
